module.exports = __webpack_public_path__ + "static/img/indomaret.e2499ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indomaret.png
// module id = o1ju
// module chunks = 1